module.exports = __webpack_public_path__ + "static/diy_recipe_dropbear_mobile_thumbnail_alt-66793cc5df2128235ac7b7f2b0fb453b.jpg";